import { Component } from 'react';
import EditorFaq from "../components/EditorFaq";
import GameData from "../mobx/GameData";
import { NamEditor } from "../components/nes/NamEditor";
import { observe } from "mobx";
import ApplicationState from "../mobx/ApplicationState";
import { Container, Row, Col, Modal, Button } from 'react-bootstrap';
import NotFound from './NotFound';
import { LinkContainer } from 'react-router-bootstrap';

export default class StaticScreenEditorPage extends Component {

    gameDataCleanup = null;
    confirmData = {
        resolve: null,
        reject: null,
        promise: null
    };

    constructor(props) {
        super(props);

        this.state = {
            screenId: null,
            error: false,
            screen: null,
            
            awaitingConfirm: false,
            awaitingConfirmDelete: false,
            awaitingConfirmAction: 'Do it'
        };

        const pathSplit = window.location.pathname.split('/');
        if (pathSplit.length < 3) {
            // Failed
            this.state.error = true;
            return;
        }
        this.state.screenId = pathSplit[3];
        this.state.screen = GameData.currentGame.staticScreens.find(s => s.id === this.state.screenId);

        if (!this.state.screen) {
            this.state.error = true;
            console.error('Could not find the screen');
        }

    }

    componentDidMount() {
        this.gameDataCleanup = observe(GameData, () => { 
            this.forceUpdate()
        });
    }

    componentWillUnmount() {
        if (this.gameDataCleanup) {
            this.gameDataCleanup();
        }
    }

    async testUnsavedChanges(event) {
        if (ApplicationState.currentPageHasUnsavedChanges) {
            event.preventDefault();
            try { 
                await this.showConfirm('Continue?');
            } catch (e) { 
                /* user cancelled, ignore and bail. */ 
                return; 
            }
        }
        ApplicationState.unsetCurrentPageUnsaved();
        event.target.closest('[href]').click();
    }

    showConfirm(action) {
        this.confirmData.promise = new Promise((resolve, reject) => {
            this.confirmData.resolve = resolve;
            this.confirmData.reject = reject;
        });
        this.setState({
            awaitingConfirm: true,
            awaitingConfirmAction: action
        });

        return this.confirmData.promise;
    }

    cancelConfirm() {
        this.confirmData.reject();
        this.confirmData = {
            promise: null,
            resolve: null, 
            reject: null
        };
        this.setState({awaitingConfirm: false, awaitingConfirmDelete: false})
    }

    continueConfirm() {
        this.confirmData.resolve();
        this.confirmData = {
            promise: null,
            resolve: null, 
            reject: null
        };
        this.setState({awaitingConfirm: false, awaitingConfirmDelete: false})
    }


    render() {
        if (this.state.error) {
            return <NotFound />
        }
        return (
            <div className="static-screen-editor-page">
                <Modal backdrop="static" show={this.state.awaitingConfirm} onHide={() => this.cancelConfirm()} aria-labelledby="Save Changes">
                    <Modal.Header closeButton>
                        <Modal.Title>Unsaved changes</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>You have unsaved changes on the current level. If you do not save, you will lose them. Do you want to continue?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.cancelConfirm()}>Cancel</Button>
                        <Button variant="danger" onClick={() => this.continueConfirm()}>{this.state.awaitingConfirmAction}</Button>
                    </Modal.Footer>
                </Modal>

                <Container>
                    <Row>
                        <Col>

                            <h1>
                                Edit Screen: {this.state.screen.title}
                            </h1>
                            <p className="mt-3">
                                You can edit your screen's graphics here. Go to the "Other Screens" page to re-order the screen.
                                <LinkContainer className="float-end" to="/builder/static-screens" onClick={event => this.testUnsavedChanges(event)} style={{marginRight: "1.5rem"}}>
                                    <Button variant="secondary">Back to Screen List</Button>
                                </LinkContainer>

                            </p>

                            <div className="mt-3">
                                <NamEditor screenId={this.state.screen.id} />
                            </div>
                            <EditorFaq />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}